<div class="flash-message alert" [class.show-close-btn]="message.showCloseBtn"  [class.close-on-click]="message.closeOnClick"
        [ngClass]="message.cssClass" (click)="message.closeOnClick ? message.close(message) : null;"
        *ngFor="let message of flashMessageService.messages | async as messages; index as i;" [@flash]="'in'">
    <div class="flash-message-text">{{ message.text }}</div>
    <a class="close-btn" (click)="$event.stopPropagation(); message.close(message);"><i class="mi mi-close"></i></a>
</div>
